<template>
    <div class="card shadow sidebarformat">
        <div v-for="gnews in sidebarnews" class="newslistformat">
          <a href="#" @click.prevent="$emit('getclickedId', $event.target.value=`${gnews.hpnewsid}`)" class="sidebarformat"><div class="dateformatcss">{{ dateTime(gnews.hpnewsdate)}}</div>
            <div v-html="gnews.hpnewsdesc" class="newslistcss"></div>
            <span class="iconspan"><i class="fa-regular fa-circle-down"></i></span></a>
        </div>
   </div>
</template>

<script>
 import moment from 'moment';
export default {
    props: ['sidebarnews'],

    methods: {
      dateTime(value) {
      return moment(value).format('YYYY-MMMM-DD');
    },
    getclickedId($event) {
    // id: $event.target.value
    this.$emit('getclickedId', $event.target.value)
    },
    }
}
</script>

<style scoped>
.sidebarformat {
    padding: 20px;
    text-decoration: none;
  }
  .newslistformat {
    border-bottom: thin #003 solid;
    padding-top: 20px;
  }
  .newslistcss {
    padding-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
    color: #003;
  }
  .dateformatcss {
    color: rgb(98, 98, 104);
    font-weight: bold;
    font-size: 16px;;
  }
  .iconspan {
    float:right; 
    margin-top: -40px;
    color: orangered;
    font-size: 30px;
  }
/* Move the background and make it larger. 
/* Media Query CSS*/
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
 
  }
  
  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 600px) {
  
  
  }
  
  
  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
  
  
  /*@-moz-document url-prefix() {
   
  }*/
  }
  
  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {

  
  @-moz-document url-prefix() {
   
  
  }
  }
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
  
  } 
  
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1400px) {
  
  } 
</style>